<template>
    <v-card class="editor pa-0 ma-0 d-flex flex-column" elevation='0'>
        <v-card :disabled="editorDisabled" elevation='0' class="flex-grow-0 flex-shrink-0">
            <div class="form-item form-item-width-1 mt-2">
                <label class="form-item-label py-0 mt-0 mr-0">编号:</label>
                <v-text-field 
                    class="form-item-value py-0 mr-0 readonly_input_item" 								
                    outlined
                    dense 
                    placeholder=""
                    readonly
                    :value="billData.id==-1?'':billData.id"
                >
                </v-text-field>	
            </div>

            <div class='dash-line'></div>

            <div class="d-flex flex-row mt-2">
                <div class="form-item form-item-width-2 mb-1">
                    <label class="form-item-label mt-1 mr-1">选择门店:</label>				
                    <v-select
                        class="form-item-value"
                        v-model="billData.shopId"
                        :items="orgs"						
                        label=""
                        hide-details											
                        flat
                        item-text="shopName"
                        item-value='shopId'
                        outlined
                        dense		
                        clearable	
                        @change="shopChange()"		
                    >
                    </v-select>
                    
                </div>
                
                <div class="form-item form-item-width-1">
                    <label class="form-item-label py-0 mt-0 mr-0">收款台:</label>
                        <v-text-field 
                            class="form-item-value py-0 mr-0 " 								
                            outlined
                            dense 
                            placeholder=""                                    
                            v-model="billData.sktno"
                        >
                        </v-text-field>	
                </div>

                <div class="form-item form-item-width-1">
                    <label class="form-item-label py-0 mt-0 mr-0">小票号:</label>
                    <v-text-field 
                        class="form-item-value py-0 mr-0 " 								
                        outlined
                        dense 
                        placeholder=""                                    
                        v-model="billData.fphm"
                    >
                    </v-text-field>	
                </div>

                <div class="form-item form-item-width-1">
                    <label class="form-item-label py-0 mt-0 mr-0">券面值:</label>
                    <v-text-field 
                        class="form-item-value py-0 mr-0 careful_input_item" 								
                        outlined
                        dense 
                        placeholder=""           
                        v-model="billData.couponAmount"
                    >
                    </v-text-field>	
                </div>


            </div>

            <div class="d-flex flex-row my-4">
                
                <div class="form-item form-item-width-2">
                    <label class="form-item-label py-0 mt-0 mr-0">券号:</label>
                    <v-text-field 
                        class="form-item-value py-0 mr-0 readonly_input_item" 								
                        outlined
                        dense 
                        placeholder=""                                    
                        v-model="billData.couponNo"
                        readonly
                    >
                    </v-text-field>	
                </div>

                <div class="form-item form-item-width-1">
                    <label class="form-item-label py-0 mt-0 mr-0">券名称:</label>
                    <v-text-field 
                        class="form-item-value py-0 mr-0 readonly_input_item" 								
                        outlined
                        dense 
                        placeholder=""  
                        readonly         
                        v-model="billData.couponName"
                    >
                    </v-text-field>	
                </div>

                
            </div>

            <div class='dash-line'></div>

            <div class="d-flex flex-row my-4">
                
                <div class="form-item form-item-width-1">
                    <label class="form-item-label py-0 mt-0 mr-0">活动号:</label>
                    <v-text-field 
                        class="form-item-value py-0 mr-0 readonly_input_item" 								
                        outlined
                        dense 
                        placeholder=""                                    
                        v-model="billData.couponActivityId"
                        readonly
                    >
                    </v-text-field>	
                </div>

                <div class="form-item form-item-width-2">
                    <label class="form-item-label py-0 mt-0 mr-0">活动名:</label>
                    <v-text-field 
                        class="form-item-value py-0 mr-0 readonly_input_item" 								
                        outlined
                        dense 
                        placeholder=""  
                        readonly         
                        v-model="billData.couponActivityName"
                    >
                    </v-text-field>	
                </div>

                <div class="form-item form-item-width-1">
                    <label class="form-item-label py-0 mt-0 mr-0">开始日期:</label>
                    <v-text-field 
                        class="form-item-value py-0 mr-0 readonly_input_item" 								
                        outlined
                        dense 
                        placeholder=""                                    
                        :value="billData.couponActivityStartDate"
                        readonly
                    >
                    </v-text-field>	
                </div>

                <div class="form-item form-item-width-1">
                    <label class="form-item-label py-0 mt-0 mr-0">截至日期:</label>
                    <v-text-field 
                        class="form-item-value py-0 mr-0 readonly_input_item" 								
                        outlined
                        dense 
                        placeholder=""  
                        readonly         
                        :value="billData.couponActivityEndDate"
                    >
                    </v-text-field>	
                </div>
                
            </div>

            
        </v-card>

        <div class='dash-line'></div>

        <div class="flex-grow-1 flex-shrink-1">

        </div>

        <div class="d-flex flex-row mt-2">
                <div class="form-item form-item-width-1">
                    <label class="form-item-label py-0 mt-0 mr-0">操作员:</label>
                    <v-text-field 
                        class="form-item-value py-2 mr-0 pl-2" 								
                        readonly
                        placeholder=""            
                        v-model="billData.operName"
                    >
                    </v-text-field>	
                </div>
                
                <div class="form-item form-item-width-2">
                    <label class="form-item-label py-0 mt-0 mr-0">保存时间:</label>
                    <v-text-field 
                        class="form-item-value py-2 mr-0 pl-2" 								
                        placeholder=""   
                        readonly                                 
                        v-model="billData.createTime"
                    >
                    </v-text-field>	
                </div>    

            </div>

        <ActivitySelectDialog
            ref="selectActivityDialog"
            @couponActivitySelected="couponActivitySelected"
        />

    </v-card>
</template>

<script>

    import EditorState from '../../../../base/bill/EditorState.js';
    import ActivitySelectDialog from '../activity/ActivitySelectDialog.vue';
    import BackendSendApi from "../../../../../api/sm/market/printcoupon/BackendSendApi.js";
    import CouponActivityApi from "../../../../../api/sm/market/printcoupon/CouponActivityApi.js";

    import Permission from "../../../../../api/smp/auth/Permission.js";

    import { setTimeout } from 'timers';

    export default {
        name:'SmMarketPrintcouponBackendSendEditor',
        props:['context'],
        components:{
            'ActivitySelectDialog':ActivitySelectDialog,
        },
        data () {
            return {
                selectedOrgId:-1,
                orgs:[],
                printing:false,
                shopCouponActivitys:[],

                billData:{
                    
                    coupons:[],

                    id:-1,
                    shopId:'',
                    shopName:'',
                    sktno:'',
                    fphm:'',
                    operId:-1,
                    operName:'',
                    createTime:'',

                    couponNo:'',
                    couponName:'',

                    couponAmount:'',
                    couponActivitys:[],
                    couponActivity:{},
                    couponActivityId:'',
                    couponActivityName:'',
                    couponActivityStartDate:'',
                    couponActivityEndDate:'',

                },
                editorState:EditorState.BROWSING,

            }
        },
        computed:{ 
            editorDisabled(){
                console.log("editorDisabled");
                return (this.editorState!=EditorState.EDITING);
            },
        },
        methods:{
            getContext(){
                return this.context;
            },

            getBill(){
                return this.getContext().bill;
            },
            getMessageDialogHelper(){
                return  this.getContext().messageDialogHelper;
            },
            getBillData(){
                return this.billData;
            },
            getBillId(){
                return this.billData.billId;
            },
            getSignals () {
                return this.context.signals;
            },

            initSignals(){
                if(!this.signalInited){
                    this.initCustomCommandAction();
                    this.signalInited = true;
                }
            },
            loadTicketAction(){
                let me = this;
                let dialog = me.$refs.ticketSelectDialog;
                console.log('loadTicketAction');
                console.log(me);
                console.log(dialog);
                if(dialog){
                    dialog.clear();
                    dialog.setVisible(true);
                }
            },
            initCustomCommandAction () {
                let me = this;
                let signal = null;
                signal = this.getSignals().customCommandAsked;
                signal.add(function (param) {
                    //console.log("custom command execute ");;
                    //console.log(param);
                    // console.log(signal);
                    if(param.command=="LOAD_TICKET"){
                        me.loadTicketAction();
                    }else if(param.command=="SELECT_ACTIVITY"){
                        me.selectActivityAction();
                    }else if(param.command=="PRINT_COUPON"){
                        me.printCouponAction();
                    }
                });
            },

            async loadOrgs(){
                let me = this;
                let queryShopPriviledgeResp = await Permission.queryShopPriviledge();
                console.log("load shop previledge returned;");

                console.log(queryShopPriviledgeResp);
                
                let data = queryShopPriviledgeResp.data;
                if((!data)||(!(data.code))||(data.code!=200)){
                    let msg=data.msg;
                    msg = ((!msg)||(msg==''))?'获取门店权限情况失败':msg;
                    throw new Error(msg);
                    return;
                }
                if((!data.data)||(!data.data.shopPriviledges)){
                    throw new Error('获取门店权限情况失败(无会话数据)');
                    return;
                }
                
                this.orgs = data.data.shopPriviledges;
            },

            reload(sendId){
                let me = this;
                let signal = null;
                signal = this.getSignals().browseBillAsked;
                signal.dispatch({id:sendId});
            },


            async loadShopCouponActivitysRemote(){
                let me = this;
                let params={ shopId:me.billData.shopId };
                let queryCouponActivityResp = await CouponActivityApi.queryCouponActivity(params);
                console.log("load coupon activity returned;");

                console.log(queryCouponActivityResp);

                let data = queryCouponActivityResp.data;
                if((!data)||(!(data.code))||(data.code!=200)){
                    let msg=data.msg;
                    msg = ((!msg)||(msg==''))?'获取打印送券活动失败':msg;
                    throw new Error(msg);
                    return;
                }
                if((!data.data)||(!data.data.couponActivitys)){
                    throw new Error('获取打印送券活动失败(无会话数据)');
                    return;
                }
                
               return data.data.couponActivitys;
            },

            selectActivityAction(){
                let me = this;
                let dialog = me.$refs.selectActivityDialog;
                dialog.clear();
                dialog.setVisible(true);
                try{
                    dialog.setActivitys(this.shopCouponActivitys);
                    dialog.setMultiSelect(false);
                }catch(err){
                    this.errMsg("错误","加载券活动发生错误："+err.message);
                    return;
                }
            },

            couponActivitySelected(params){

                let selectdActivitys = params.selectedActivitys;
                if(!selectdActivitys || !selectdActivitys.length){
                    this.errMsg("错误","您还未选择券活动");
                    return;
                }else if(selectdActivitys.length && selectdActivitys.length!=1){
                    this.errMsg("错误","只能选择一个券活动");
                    return;
                }
              this.billData.couponActivitys = selectdActivitys;
              this.billData.couponActivity = selectdActivitys[0];
              this.billData.couponActivityId = this.billData.couponActivity.activityId;
              this.billData.couponActivityName = this.billData.couponActivity.activityName;
              this.billData.couponActivityStartDate = this.billData.couponActivity.startDate;
              this.billData.couponActivityEndDate = this.billData.couponActivity.endDate;
            },
            clear(){
                this.billData = this.getBill().getEmptyData();
            },

            //--need implement--
            setState(state){
                this.editorState = state;
            },
            async printCouponAction(){
                let me = this;
                me.printing  = true;
                setTimeout(function(){me.printing=false;},5000);
                try{
                    let backendSend = await this.printCouponRemote();
                    me.getMessageDialogHelper().infoMsg('成功','补打请求已发送');
                    me.reload(me.billData.id);
                }catch(err){
                    console.log(err);
                    me.getMessageDialogHelper().errMsg('错误','补打请求异常:'+err.message);
                    return;
                }
            },
            async printCouponRemote(){
                let me = this;
                let bill={};
                
                bill.sendId = this.billData.id; 

                let backendSendPrintResp = await BackendSendApi.backendSendPrint(bill);
                console.log("backendSendPrint  returned;");

                console.log(backendSendPrintResp);
                
                let data = backendSendPrintResp.data;
                if((!data)||(!(data.code))||(data.code!=200)){
                    let msg=data.msg;
                    msg = ((!msg)||(msg==''))?'打印券异常':msg;
                    if(data.msg_detail)
                        msg = msg+","+data.msg_detail;
                    throw new Error(msg);
                    return;
                }
                if((!data.data)||(!data.data.backendSend)){
                    throw new Error('打印券异常(无会话数据)');
                    return;
                }
                let backendSend = data.data.backendSend;
                
                //this.checkSaleHeadData(saleHead);
                return backendSend;

            },

            async loadDataRemote(id){
                let me = this;
                console.log(" loadDataRemote backendSendApi ");
                console.log(id);
                let getBackendSendResp = await BackendSendApi.getBackendSend({id:id});
                console.log("load backendSend returned;");

                console.log(getBackendSendResp);
                
                let data = getBackendSendResp.data;
                if((!data)||(!(data.code))||(data.code!=200)){
                    let msg=data.msg;
                    msg = ((!msg)||(msg==''))?'获取后台送券请求信息失败':msg;
                    if(data.msg_detail)
                        msg = msg+data.msg_detail;
                    throw new Error(msg);
                    return;
                }
                if((!data.data)||(!data.data.backendSend)){
                    throw new Error('获取后台送券请求信息失败(无会话数据)');
                    return;
                }
                let backendSend = data.data.backendSend;
                
                this.transformRemoteRec(backendSend);
                return backendSend;
            },
            transformRemoteRec(backendSend){
                let coupons = backendSend.coupons;
                let activitys = backendSend.couponActivitys
                if(activitys.length && activitys.length>0){
                    backendSend.couponActividy = activitys[0];
                    backendSend.couponActivityId = backendSend.couponActividy.activityId;
                    backendSend.couponActivityName = backendSend.couponActividy.activityName;
                    backendSend.couponActivityStartDate = backendSend.couponActividy.startDate;
                    backendSend.couponActivityEndDate = backendSend.couponActividy.endDate; 
                }
                if(coupons.length && coupons.length>0){
                    backendSend.couponNo = coupons[0].couponNo;
                    backendSend.couponName = coupons[0].couponName;
                }
            },
            //回调注意传入单据数据信息
            async  loadData(billInfo,loadRemote,loadSuccessCallback,loadFailCallback){
                console.log("backendsend coupon loadData");
                console.log(billInfo);
                let me = this;
                this.clear();
                if(billInfo.id==-1){
                    this.billData = billInfo;
                }else if(!loadRemote){
                    this.billData = billInfo;
                }else{
                    let backendSend=null;
                    //远程加载
                    try{
                        backendSend = await this.loadDataRemote(billInfo.id);
                    }catch(err){
                        console.log(err);
                        me.getMessageDialogHelper().errMsg('错误','加载后台送券信息失败:'+err.message);
                        loadFailCallback(this.billData);
                        return;
				    };
                    this.billData = backendSend;                    
                }
                loadSuccessCallback(this.billData);
                
            },
            //回调注意传入单据数据信息,建议所有持久化服务程序，执行完后在服务端立即执行查询并返回，节省一次调用
            async saveDataRemote(bill){
                let saveBackendSendResp = await BackendSendApi.saveBackendSend(bill);

                console.log("save backendSend  returned;");
                console.log(saveBackendSendResp);
                
                let data = saveBackendSendResp.data;
                if((!data)||(!(data.code))||(data.code!=200)){
                    let msg=data.msg;
                    msg = ((!msg)||(msg==''))?'保存后台送券请求失败':msg;
                    if(data.msg_detail)
                        msg = msg+","+data.msg_detail;
                    throw new Error(msg);
                    return;
                }
                if((!data.data)||(!data.data.backendSend)){
                    throw new Error('保存后台送券请求时返回无数据');
                    return;
                }
                let backendSend = data.data.backendSend;      
                return backendSend;
            },
            async saveData(saveSuccessCallback,saveFailCallback){
                let me = this;
                let bill={};
                
                bill.shopId = this.billData.shopId;
                bill.sktno = (this.billData.sktno+"").trim();
                bill.fphm = (this.billData.fphm+"").trim();
                bill.couponAmount = (this.billData.couponAmount+"").trim();
                bill.couponActivitys = this.billData.couponActivitys;

                if((!bill.shopId)||(bill.shopId=='')||(bill.shopId=='-1')){
                    me.getMessageDialogHelper().errMsg('错误','还未选择门店');
                    saveFailCallback(this.billData);
                    return;
                }
                if((bill.sktno=='')||(bill.fphm=='')){
                    me.getMessageDialogHelper().errMsg('错误','请录入收款台号和发票号码');
                    saveFailCallback(this.billData);
                    return;
                }
                if(bill.couponAmount==''){
                    me.getMessageDialogHelper().errMsg('错误','请录入券面值');
                    saveFailCallback(this.billData);
                    return;
                }

                if((!bill.couponActivitys)||(!bill.couponActivitys.length)||(bill.couponActivitys.length<1)){
                    me.getMessageDialogHelper().errMsg('错误','还没有合适的活动来执行发券');
                    saveFailCallback(this.billData);
                    return;
                }
                
                console.log("saving backendSend");
                console.log(bill);
                
                try{    
                    let returnedBill = await this.saveDataRemote(bill);
                    me.transformRemoteRec(returnedBill);
                    saveSuccessCallback(returnedBill);
                }catch(err){
                    console.log(err);
                    me.getMessageDialogHelper().errMsg('错误','保存补打请求信息失败:'+err.message);
                    saveFailCallback(this.billData);
                };
                
            },
            async shopChange(){
                
                this.shopCouponActivitys = [];
                this.billData.couponActivitys=[];
                this.billData.couponActivity={};
                let selectActivityDialog = this.$refs.selectActivityDialog;
                if((this.billData.shopId)&&(this.billData.shopId!=-1)){
                    let couponActivitys = await this.loadShopCouponActivitysRemote();

                    if((null!=couponActivitys)&&(couponActivitys.length)){
                        this.shopCouponActivitys = couponActivitys;
                    }

                    if((null!=couponActivitys)&&(couponActivitys.length)&&(couponActivitys.length==1)){
                        this.billData.couponActivitys = couponActivitys;
                        this.billData.couponActivity = couponActivitys[0];
                        this.billData.couponActivityId = this.billData.couponActivity.activityId;
                        this.billData.couponActivityName = this.billData.couponActivity.activityName;
                        this.billData.couponActivityStartDate = this.billData.couponActivity.startDate;
                        this.billData.couponActivityEndDate = this.billData.couponActivity.endDate; 
                    }else if(couponActivitys && couponActivitys.length && couponActivitys.length>1){
                      selectActivityDialog.setVisible(true);
                      selectActivityDialog.setMultiSelect(false);
                      selectActivityDialog.setActivitys(couponActivitys);
                    }
                }else{
                    console.log("未选择门店");
                }
            },
            deleteData(deleteSuccessCallback,deleteFailCallback){
                let bill={};

                deleteSuccessCallback(bill);
            },
            auditData(auditSuccessCallback,auditFailCallback){
                let bill={};

                auditSuccessCallback(bill);
            },
            cancelAuditData(cancelAuditSuccessCallback,cancelAuditFailCallback){
                let bill={};

                cancelAuditSuccessCallback(bill);
            },
            voidData(voidSuccessCallback,voidFailCallback){
                let bill={};

                voidSuccessCallback(bill);
            },
            cancelVoidData(cancelVoidSuccessCallback,cancelVoidFailCallback){
                let bill={};

                cancelVoidSuccessCallback(bill);
            },
            putOnData(putOnSuccessCallback,putOnFailCallback){
                let bill={};

                putOnSuccessCallback(bill);
            },
            withdrawData(withdrawSuccessCallback,withdrawFailCallback){
                let bill={};

                withdrawSuccessCallback(bill);
            },

            //用于指示按钮可用性,不在此
            canEdit(){
                return true;    
            },
            canDelete(){
                return false;
            },
            
            canSave(){
                return true;
            },
            canAudit(){
                return false;
            },
            canCancelAudit(){
                return false;
            },
            canVoid(){
                return false;
            },
            canCancelVoid(){
                return false;
            },
            canPutOn(){
                return false;
            },
            canWithdraw(){
                return false;
            },

            canRestore(){
                if(this.billData.status==0)
                    return true;
                return false;    
            },
            canStop(){
                if(this.billData.status==1)
                    return true;
                return false;    
            },
            
            canPrintCoupon(){
                if((this.billData)&&(this.billData.createTime)){
                    let theCreateTime = new Date(Date.parse(this.billData.createTime));
                    let startDate = new Date(new Date(new Date().toLocaleDateString()).getTime());
                    let endDate =  new Date(startDate.getTime() + 24 * 60 * 60 * 1000);

                    // console.log(theCreateTime+","+startDate+","+endDate);
                    // console.log(theCreateTime.getTime()+","+startDate.getTime()+","+endDate.getTime());
                    if(((theCreateTime.getTime()>=startDate.getTime()) && (theCreateTime.getTime()<endDate.getTime())&&(!this.printing))){
                        return true;
                    }
                }
                return false;
            },

        },
        created(){
            console.log("user Editor created");
            this.billData = this.getBill().getEmptyData();
            this.initSignals();
            this.loadOrgs();
        },
        mounted(){ 
            console.log("user Editor mounted");
            if(!this.billData)
                this.billData = this.getBill().getEmptyData();
            
        },
    }
</script>

<style scoped>
    .readonly_input_item{
		background-color:lightgrey;
	}
	.careful_input_item{
		background-color:lightblue;
	}

    .table-title{
        background-color:lightblue;
        color:black;
    }

    .table-title-container{
        border-bottom: solid 2px lightblue;
    }

    .dash-line{
		border-top:1px dashed #333333;
	}
    .active-tab-view{
		padding:0px;
		margin: 0px;
		width:100%;
		height:100%;
        overflow-y: auto;
        overflow-x: hidden;
	}
	
	.tabViewContainer{
        /*
		overflow: scroll;
		width:100%;
		height:100%;
        */
        visibility: inherit;
	}
	.active-tab{
		background-color: lightblue;
	}

    .v-tabitem-group {
		border-top:2px solid lightblue;
		padding-top: 10px;
	}

    .tabPane-root{
		padding:0px;
		margin: 0px;
		width:100%;
		height:100%;
	}

    .queryResultPaneRoot{
        position:absolute;
        left:0px;
        top:0px;
        bottom: 0px;
        right:0px;
        overflow-y: hidden;
    }

    .result-table{
        width:100%;
        height:100%;
    }

    .careful_input_item{
		background-color:lightblue;
	}

</style>
